import * as React from 'react';

import { cn } from '@drisk-ai/ui/cn';
import { Search } from 'lucide-react';

const SearchInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'>
>(({ className, type, ...props }, ref) => {
  return (
    <div
      className={cn(
        'flex gap-2 items-center h-10 rounded-md border border-input bg-background px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
    >
      <Search size={16} className="text-muted-foreground" />
      <input
        type={type}
        className={cn('outline-none w-full md:text-sm')}
        ref={ref}
        {...props}
      />
    </div>
  );
});
SearchInput.displayName = 'SearchInput';

export { SearchInput };
